import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index.js";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		component: () => import("@/views/Resumen.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/login",
		name: "Login",
		component: () => import("@/views/Login.vue"),
		beforeEnter: (to, from, next) => {
			if (store.getters.isLoggedIn) next({ name: "Home" });
			else next();
		},
	},
	{
		path: "/logout",
		name: "Logout",
		beforeEnter: async (to, from, next) => {
			if (confirm("¿Estás seguro de que quieres cerrar sesión?")) {
				await store.dispatch("logout");
				router.push("/login");
			}
		},
	},
	{
		path: "/sips",
		name: "Sips",
		component: () => import("@/views/Sips.vue"),
		meta: { requiresAuth: true, acceso: 'VER_CONTRATOS' },
	},
	{
		path: "/clientes",
		name: "Clientes",
		component: () => import("@/views/clientes/Clientes.vue"),
		meta: { requiresAuth: true, acceso: 'VER_CONTRATOS' },
	},
	{
		path: "/contratos",
		name: "Contratos",
		component: () => import("@/views/contratos/Contratos.vue"),
		meta: { requiresAuth: true, acceso: "VER_CONTRATOS" },
	},
	// {
	// 	path: "/contratos_old",
	// 	name: "ContratosOld",
	// 	component: () => import("@/views/contratos/Contratos.vue"),
	// 	meta: { requiresAuth: true, acceso: "VER_CONTRATOS" },
	// },
	{
		path: "/borradores",
		name: "Borradores",
		component: () => import("@/views/contratos/Borradores.vue"),
		meta: { requiresAuth: true, acceso: "VER_CONTRATOS" },
	},
	{
		path: "/detalles_borrador",
		name: "DetallesBorrador",
		component: () => import("@/views/contratos/DetallesBorrador.vue"),
		meta: { requiresAuth: true, acceso: 'VER_CONTRATOS' },
	},
	{
		path: "/documentacion",
		name: "Documentacion",
		component: () => import("@/views/Documentacion.vue"),
		meta: { requiresAuth: true, acceso: 'VER_CONTRATOS' },
	},
	{
		path: "/cargar_contrato",
		name: "CargarContrato",
		component: () => import(`@/views/contratos/CargarContrato.vue`),
		meta: { requiresAuth: true, acceso: "CREAR_CONTRATO" },
	},
	{
		path: "/detalles_contrato",
		name: "DetallesContrato",
		component: () => import("@/views/contratos/DetallesContrato.vue"),
		props: (route) => Object.assign({}, route.query, route.params),
		meta: { requiresAuth: true },
	},
	{
		path: "/detalles_cups",
		name: "DetallesCups",
		component: () => import("@/views/DetallesCups.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/detalles_cliente",
		name: "DetallesCliente",
		component: () => import("@/views/clientes/DetallesCliente.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/facturas",
		name: "Facturas",
		component: () => import("@/views/facturacionContratos/Facturas.vue"),
		props: (route) => Object.assign({}, route.query, route.params),
		meta: { requiresAuth: true, acceso: 'VER_FACTURAS_CONTRATOS' },
	},
	{
		path: "/facturacion",
		name: "Facturacion",
		component: () => import("@/views/facturacionContratos/Facturas.vue"),
		meta: { requiresAuth: true, acceso: 'VER_FACTURAS_CONTRATOS' },
	},
	{
		path: "/autofacturar",
		name: "Autofacturar",
		component: () =>
			import("@/views/facturacionColaboradores/ContratosSinFacturar.vue"),
		meta: { requiresAuth: true, acceso: 'CREAR_FACTURA_COLABORADORES' },
	},
	{
		path: "/autofacturas",
		name: "Autofacturas",
		component: () => import("@/views/facturacionColaboradores/Facturas.vue"),
		meta: { requiresAuth: true, acceso: 'VER_FACTURAS_COLABORADORES' },
	},
	{
		path: "/colaboradores",
		name: "Colaboradores",
		component: () => import("@/views/facturacionColaboradores/Colaboradores.vue"),
		meta: { requiresAuth: true, acceso: 'VER_COLABORADORES' },
	},
	{
		path: "/nuevo_colaborador",
		name: "NuevoColaborador",
		component: () => import("@/views/facturacionColaboradores/NuevoColaborador.vue"),
		meta: { requiresAuth: true, acceso: 'CONTROL_COLABORADORES' },
	},
	{
		path: "/incidencias",
		name: "Incidencias",
		component: () => import("@/views/incidencias/Incidencias.vue"),
		props: (route) => Object.assign({}, route.query, route.params),
		meta: { requiresAuth: true, acceso: 'VER_INCIDENCIAS' },
	},
	{
		path: "/impagados",
		name: "Impagados",
		component: () => import("@/views/impagados/Impagados.vue"),
		props: (route) => Object.assign({}, route.query, route.params),
		meta: { requiresAuth: true, acceso: 'CONTROL_IMPAGADOS' },
	},
	{
		path: "/pruebas",
		name: "Pruebas",
		component: () => import("@/views/Pruebas.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/*",
		redirect: "/",
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

import { decode64 } from "@/utils/index.js";

const validarToken = (token) =>
	new Date(JSON.parse(decode64(token)).FechaExpiracion).getTime() >
	new Date().getTime();

router.beforeEach(async (to, from, next) => {
	if (
		to.matched.some((record) => record.meta.requiresAuth) &&
		(store.getters.getToken === null || store.getters.getPermisos === null || !validarToken(store.getters.getToken))
	) {
		let msg = store.getters.getToken != null ? "La sesión ha expirado" : "";
		await store.dispatch("logout");
		next({ name: "Login", query: { redirect: to.path, msg } });
	}

	if (to.matched.some((record) => record.meta.acceso)) {
		const acceso = to.matched.find((record) => record.meta.acceso).meta.acceso;
		if ( !!( store.getters.getDecodedJwtEmpresa.permisos_b & store.getters.getPermisos[acceso] ) ) next();
		else next({ name: "Home" });
	}

	if (to.matched.some((record) => record.meta.soloLocal)) {
		if (process.env.NODE_ENV == "development") next();
		else next({ name: "Home" });
	}
	next();
});

export default router;
